module.exports = __webpack_public_path__ + "static/media/image-card-4.b0f61298.png";